<div [formGroup]="signoffForm" id="signOff-form">
	<div class="mt-4 grid grid-rows-1 gap-4">
		<div
			class="mb-6 flex h-[40px] items-center justify-start bg-blue-20 px-4 text-lg font-bold text-black lg:bg-violet-light lg:text-violet"
		>
			Recommendation by Instructor/Examiner
		</div>
	</div>

	<div class="grid grid-cols-2 gap-4 p-4">
		<div>
			<p class="font-bold">
				Is this a training or check session?
				<span class="text-xs italic text-red">*Required</span>
			</p>
			<mat-radio-group aria-label="Select an option" class="mt-8 grid grid-cols-3 gap-4" formControlName="category">
				<mat-radio-button value="Training" [color]="'primary'"
					><span class="text-base font-medium text-violet">Training</span></mat-radio-button
				>
				<mat-radio-button value="Check" [color]="'primary'"
					><span class="text-base font-medium text-violet">Check</span></mat-radio-button
				>
			</mat-radio-group>
		</div>
	</div>
	<hr class="my-2 h-px border-0 bg-gray-200 dark:bg-gray-700" />
	@if (category.value) {
		<div class="grid grid-cols-2 gap-x-4 gap-y-8 p-4">
			<div>
				<p class="font-bold">
					{{ category.value == "Training" ? "Training" : "Check" }} Session Completed
					<span class="text-xs italic text-red">*Required</span>
				</p>
				<mat-radio-group
					aria-label="Select an option"
					class="mt-8 grid grid-cols-3 gap-4"
					formControlName="sessionCheck"
				>
					<mat-radio-button [value]="true" [color]="'primary'"
						><span class="text-base font-medium text-violet">Yes</span></mat-radio-button
					>
					<mat-radio-button [value]="false" [color]="'primary'"
						><span class="text-base font-medium text-violet">No</span></mat-radio-button
					>
				</mat-radio-group>
			</div>
			<div>
				<p class="font-bold">
					{{ category.value == "Training" ? "Training" : "Check" }} {{ !isIAA ? "Objectives Are Met" : "Outcome" }}
					<span class="text-xs italic text-red">*Required</span>
				</p>
				<mat-radio-group
					aria-label="Select an option"
					class="mt-8 grid grid-cols-3 gap-4"
					formControlName="objectiveCheck"
				>
					@if (category.value === "Training") {
						<mat-radio-button [value]="true" [color]="'primary'"
							><span class="text-base font-medium text-violet">
								{{ !isIAA ? "Yes" : "Satisfactory" }}
							</span></mat-radio-button
						>
						<mat-radio-button [value]="false" [color]="'primary'"
							><span class="text-base font-medium text-violet">
								{{ !isIAA ? "No" : "Not Satisfactory" }}
							</span></mat-radio-button
						>
					} @else {
						<mat-radio-button [value]="true" [color]="'primary'"
							><span class="text-base font-medium text-violet">
								{{ !isIAA ? "Yes" : "PASS" }}
							</span></mat-radio-button
						>
						<mat-radio-button [value]="false" [color]="'primary'"
							><span class="text-base font-medium text-violet">
								{{ !isIAA ? "No" : "FAIL" }}
							</span></mat-radio-button
						>
						@if (isIAA) {
							<mat-radio-button [value]="false" [color]="'primary'"
								><span class="text-base font-medium text-violet">INCOMPLETE</span></mat-radio-button
							>
						}
					}
				</mat-radio-group>
			</div>
			<div [class.hidden]="category.value === 'Check'">
				<p class="font-bold">Cleared for Check <span class="text-xs italic text-red">*Required</span></p>
				<mat-radio-group
					aria-label="Select an option"
					class="mt-8 grid grid-cols-3 gap-4"
					formControlName="clearanceCheck"
				>
					<mat-radio-button [value]="true" [color]="'primary'"
						><span class="text-base font-medium text-violet">Yes</span></mat-radio-button
					>
					<mat-radio-button [value]="false" [color]="'primary'"
						><span class="text-base font-medium text-violet">No</span></mat-radio-button
					>
					<mat-radio-button value="N/A" [color]="'primary'"
						><span class="text-base font-medium text-violet">Not Applicable</span></mat-radio-button
					>
				</mat-radio-group>
			</div>
		</div>
	}

	<div class="mt-4 grid grid-rows-1 gap-4">
		<div
			class="mb-6 flex h-[40px] items-center justify-start bg-blue-20 px-4 text-lg font-bold text-black lg:bg-violet-light lg:text-violet"
		>
			Sign Off
		</div>
	</div>

	<div class="grid grid-cols-2 gap-4 py-4">
		<div>
			<div>
				<mat-label for="form-name">Instructor Name</mat-label>
				<mat-form-field appearance="outline" class="form-field-responsive mt-1 w-full">
					<input type="text" formControlName="trainerName" matInput placeholder="" readonly />
				</mat-form-field>
			</div>

			<div class="cursor-pointer">
				<mat-label
					(click)="toggleLicenseNumber(!useInstructorLicense?.value)"
					for="form-name"
					class="flex items-center justify-start gap-4"
				>
					<div
						class="transition-all duration-200"
						[class.text-grey-40]="!useInstructorLicense?.value"
						[class.text-violet]="useInstructorLicense?.value"
					>
						License Number
					</div>
					<div>
						<div class="switch">
							<div
								class="thumb"
								[class.-left-2]="useInstructorLicense?.value"
								[class.left-2]="!useInstructorLicense?.value"
							></div>
						</div>
					</div>
					<div
						class="transition-all duration-200"
						[class.text-grey-40]="useInstructorLicense?.value"
						[class.text-violet]="!useInstructorLicense?.value"
					>
						Examiner Number
					</div>
				</mat-label>
				<mat-form-field appearance="outline" class="form-field-responsive mt-1 w-full">
					<input type="text" formControlName="instructorLicenseNumber" matInput placeholder="" />
				</mat-form-field>
			</div>
		</div>
		<div>
			<label for="form-name">Instructor Signature</label>

			<div class="relative mt-2 flex h-36 w-full items-center justify-center rounded border border-grey-20">
				@if (instructorSignatureEditMode) {
					<button
						[disabled]="!isOnline || !signingIsValid"
						(click)="signOffModel('trainer')"
						data-size="small"
						class="aa-btn absolute right-2 top-2 h-6 px-2"
						matTooltip="Upload a new signature"
					>
						<mat-icon class="-mb-1">draw</mat-icon>
					</button>
				}
				@if (instructorHasSignaturePreview) {
					<img class="h-full w-auto" [src]="instructorSignaturePreview" alt="Signature" />
				}
			</div>
		</div>
	</div>
</div>
